(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ls-journal-ui"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(root) {
    if (root.dataset.lsjReady) return;
    root.dataset.lsjReady = 'true';
    root.classList.add('lsj-enhanced');
    const prose = root.querySelector('.lsj-prose');
    if (!prose) return;
    const headings = [...prose.querySelectorAll('h2')];
    const targets = [root.querySelector('[data-lsj-toc]'), root.querySelector('[data-lsj-mobile-toc]')];
    const used = new Set([...document.querySelectorAll('[id]')].map(e => e.id));
    headings.forEach((heading, i) => {
      if (!heading.id) { let id = 'journal-section-' + (i + 1); while (used.has(id)) id += '-item'; heading.id = id; used.add(id); }
      targets.forEach(target => { if (!target) return; const a = document.createElement('a'); a.href = '#' + heading.id; a.textContent = heading.textContent; target.appendChild(a); });
    });
    if (headings.length) { root.querySelector('.lsj-toc').hidden = false; root.querySelector('.lsj-mobile-toc').hidden = false; }
    const mobileToc = root.querySelector('.lsj-mobile-toc');
    mobileToc.open = headings.length <= 6;
    const readerMenu = document.createElement('details');
    readerMenu.className = 'lsj-reader-menu';
    const readerSummary = document.createElement('summary');
    readerSummary.textContent = root.querySelector('.lsj-breadcrumb li:nth-child(2)').textContent.trim();
    const readerNav = document.createElement('nav');
    readerNav.setAttribute('aria-label', root.querySelector('.lsj-categories').getAttribute('aria-label'));
    const home = root.querySelector('.lsj-breadcrumb a').cloneNode(true);
    readerNav.appendChild(home);
    root.querySelectorAll('.lsj-categories a').forEach(a => readerNav.appendChild(a.cloneNode(true)));
    const readerHeading = document.createElement('h2');
    readerHeading.textContent = mobileToc.querySelector('summary').textContent;
    readerNav.appendChild(readerHeading);
    targets[1].querySelectorAll('a').forEach(a => readerNav.appendChild(a.cloneNode(true)));
    readerMenu.append(readerSummary, readerNav);
    root.appendChild(readerMenu);
    readerNav.addEventListener('click', e => { if(e.target.closest('a')) readerMenu.open = false; });
    readerMenu.addEventListener('keydown', e => { if(e.key === 'Escape'){ readerMenu.open = false; readerSummary.focus(); } });
    const links = [...root.querySelectorAll('[data-lsj-toc] a')];
    const rail = root.querySelector('.lsj-rail-stage');
    const panels = [...rail.querySelectorAll('.lsj-rail-card')];
    const content = root.querySelector('.lsj-body');
    let scheduled = false;
    function update() {
      scheduled = false;
      const header = document.querySelector('.section-header');
      const mobileReading = innerWidth <= 700 && content.getBoundingClientRect().top <= 70;
      document.body.classList.toggle('lsj-mobile-reading', mobileReading);
      if(!mobileReading) readerMenu.open = false;
      const offset = mobileReading ? 64 : Math.max(95, header ? header.getBoundingClientRect().bottom + 20 : 95);
      root.style.setProperty('--lsj-top', Math.min(offset, 180) + 'px');
      const start = content.getBoundingClientRect().top + scrollY;
      const span = Math.max(1, content.offsetHeight - innerHeight * .65);
      const ratio = Math.max(0, Math.min(.9999, (scrollY - start + offset) / span));
      root.querySelector('.lsj-progress').style.width = (ratio * 100) + '%';
      let current = headings[0]; headings.forEach(h => { if (h.getBoundingClientRect().top < offset + 50) current = h; });
      links.forEach(a => { if (current && a.hash === '#' + current.id) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current'); });
      const focused = panels.findIndex(p => p.contains(document.activeElement));
      const index = focused >= 0 ? focused : Math.min(panels.length - 1, Math.floor(ratio * panels.length));
      panels.forEach((panel, i) => { if (i !== index) { panel.hidden = true; panel.classList.remove('lsj-enter'); } else if (panel.hidden) { panel.hidden = false; panel.classList.remove('lsj-enter'); void panel.offsetWidth; panel.classList.add('lsj-enter'); } });
    }
    function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }
    addEventListener('scroll', schedule, { passive: true }); addEventListener('resize', schedule); rail.addEventListener('focusout', schedule); prose.querySelectorAll('img').forEach(i => i.addEventListener('load', schedule)); update();
    root.querySelector('[data-lsj-top]').onclick = () => scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    const status = root.querySelector('[data-lsj-share-status]');
    root.querySelector('[data-lsj-copy]').onclick = async () => { try { await navigator.clipboard.writeText(root.dataset.url); status.textContent = root.dataset.copySuccess; } catch { status.textContent = root.dataset.copyFailed; } };
    const native = root.querySelector('[data-lsj-native]');
    if (navigator.share) { native.hidden = false; native.onclick = async () => { try { await navigator.share({ title: root.dataset.title, url: root.dataset.url }); } catch (e) { if (e.name !== 'AbortError') status.textContent = root.dataset.shareFailed; } }; }
    const save = root.querySelector('[data-lsj-save]'); const key = 'ls-journal-saved:' + root.dataset.url;
    function showSaved(value) { save.setAttribute('aria-pressed', String(value)); save.textContent = value ? root.dataset.saved : root.dataset.save; }
    try { showSaved(localStorage.getItem(key) === '1'); } catch {}
    save.onclick = () => { try { const next = localStorage.getItem(key) !== '1'; next ? localStorage.setItem(key, '1') : localStorage.removeItem(key); showSaved(next); } catch { root.querySelector('[data-lsj-save-status]').textContent = root.dataset.storageFailed; } };
    root.querySelectorAll('.lsj-signup').forEach(form => { form.addEventListener('submit', () => { if (!form.checkValidity()) return; const button = form.querySelector('button'); button.setAttribute('aria-busy', 'true'); button.textContent = root.dataset.sending; setTimeout(() => { button.removeAttribute('aria-busy'); button.textContent = form.dataset.originalSubmit; }, 15000); }); form.dataset.originalSubmit = form.querySelector('button').textContent; });
  }
  function boot(scope) { scope.querySelectorAll('[data-lsj-article]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
  } catch(e) { console.error(e); }
})();

})();
